@for (rowHeader of groupRowArray; track rowHeader) {
  <!-- Group Row -->
  <div class="table-row">
    @if (!isPinTo) {
      <div class="table-cell  grpRowBorder" (click)="openClose(rowHeader)">
        <span class="expand-icon"><i class="fn-global-expand"></i></span>
        <span [title]="rowHeader.rowName" class="align-middle">{{rowHeader.rowName}}</span>
        <span class="grid-badge">{{groupRowHash[rowHeader.rowName].length}}</span>
      </div>
      @for (column of columnArray; track column; let i = $index) {
        @if (isShowEmptyCell(column , i)) {
          <div class="table-cell grpRowBorder">
          </div>
        }
      }
    } @else {
      @for (item of columnArray; track item) {
        <div class="table-cell grpRowBorder">
        </div>
      }
    }
  </div>
  <!--data Row Array -->
  @for (row of groupRowHash[rowHeader.rowName]; track row) {
    <div class="table-row hw-grid-body-row" [hidden]='rowHeader.isHidden'>
      <ng-container *ngTemplateOutlet="templateRef;context:{row:row,colHeaderArray:columnArray,showAction:showAction,isPinTo:isPinTo}"></ng-container>
    </div>
  }
}